import React from 'react';
export function SellosBar() {
  return <div className="bg-[#0a0a0a] border-t border-brand-border py-6 px-6" data-id="element-268">
      <div className="max-w-[700px] mx-auto flex flex-wrap justify-center gap-6" data-id="element-269">
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-270">
          <span data-id="element-271">🔒</span>Pago 100% seguro
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-272">
          <span data-id="element-273">⚡</span>Acceso en 5 minutos
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-274">
          <span data-id="element-275">✅</span>Garantía 7 días
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-276">
          <span data-id="element-277">💳</span>MercadoPago
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-278">
          <span data-id="element-279">💳</span>Tarjeta de crédito
        </div>
        <div className="flex items-center gap-2 text-[13px] text-brand-muted" data-id="element-280">
          <span data-id="element-281">🏦</span>Transferencia bancaria
        </div>
      </div>
    </div>;
}